import { useState } from 'react';
import { FriendGroupWithMembers } from '../../../types';

/**
 * Hook to manage friend groups on the map
 */
export const useGroupsManagement = () => {
  const [groups, setGroups] = useState<FriendGroupWithMembers[]>([]);
  const [friendGroups, setFriendGroups] = useState<Map<number, { id: number; name: string; color?: string }[]>>(
    new globalThis.Map()
  );

  // Group modal
  const [showAddFriendToGroupModal, setShowAddFriendToGroupModal] = useState(false);
  const [selectedFriendForGroup, setSelectedFriendForGroup] = useState<number | null>(null);
  const [selectedGroupsForFriend, setSelectedGroupsForFriend] = useState<number[]>([]);

  // Create group in temp location modal
  const [showCreateGroupInTempModal, setShowCreateGroupInTempModal] = useState(false);
  const [newGroupDataInTempModal, setNewGroupDataInTempModal] = useState({ name: '', color: '#4a90e2' });

  return {
    // Groups data
    groups,
    setGroups,
    friendGroups,
    setFriendGroups,

    // Group modal
    showAddFriendToGroupModal,
    setShowAddFriendToGroupModal,
    selectedFriendForGroup,
    setSelectedFriendForGroup,
    selectedGroupsForFriend,
    setSelectedGroupsForFriend,

    // Create group in temp location modal
    showCreateGroupInTempModal,
    setShowCreateGroupInTempModal,
    newGroupDataInTempModal,
    setNewGroupDataInTempModal,
  };
};
